import React from "react";
import { motion } from "framer-motion";
import { Cpu, Truck, Users, Wrench, Sparkles, MapPin, Rocket } from "lucide-react";

const items = [
  { icon: Wrench, title: "Equipamentos profissionais", desc: "Hardware de competição: Direct Drive, 6DOF, Load Cell.", color: "red" },
  { icon: Cpu, title: "Tecnologia de ponta", desc: "Softwares Assetto Corsa e MS Flight Simulator com cenários reais.", color: "blue" },
  { icon: Truck, title: "Transporte próprio", desc: "Levamos a estrutura completa até seu evento.", color: "red" },
  { icon: MapPin, title: "Atendimento nacional", desc: "Atuação em todo o território brasileiro.", color: "blue" },
  { icon: Sparkles, title: "Experiência imersiva", desc: "Motion 6DOF, VR e cockpits réplicas.", color: "red" },
  { icon: Users, title: "Equipe especializada", desc: "Operadores treinados para máxima performance.", color: "blue" },
  { icon: Rocket, title: "Diversão garantida", desc: "Do briefing à ativação, entrega premium.", color: "red" },
];

export default function Differentials() {
  return (
    <section className="relative py-28 md:py-40 bg-[#080808]" data-testid="differentials-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="mb-14 flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-[1px] w-10 bg-[#E31B23]" />
              <span className="overline">Nosso diferencial</span>
            </div>
            <h2 className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
              <span className="text-white">POR QUE </span>
              <span className="text-transparent" style={{ WebkitTextStroke: "1px #008CFF" }}>ESCOLHER</span>
              <br />
              <span className="neon-red">SIM EXPERIENCE?</span>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.06 }}
              className="group relative rounded-2xl border border-white/5 bg-[#0c0c0c] p-8 overflow-hidden hover:border-white/20 transition-colors"
              data-testid={`diff-${i}`}
            >
              <div className={`absolute -top-16 -right-16 w-56 h-56 rounded-full blur-[80px] opacity-0 group-hover:opacity-40 transition-opacity duration-500 ${it.color === "blue" ? "bg-[#008CFF]" : "bg-[#E31B23]"}`} />
              <div className={`relative w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${it.color === "blue" ? "bg-[#008CFF]/10 text-[#008CFF]" : "bg-[#E31B23]/10 text-[#E31B23]"}`}>
                <it.icon className="w-6 h-6" />
              </div>
              <h3 className="font-display font-bold text-xl text-white leading-tight">{it.title}</h3>
              <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{it.desc}</p>
              <div className="mt-6 overline text-neutral-600 text-[10px]">0{i + 1} / 07</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
